import { useEffect } from 'react';
import { UseAuthLayoutReturn } from './types';

/**
 * AuthLayoutコンポーネントのロジックを管理するカスタムフック
 * @returns カスタムフックの戻り値オブジェクト
 */
export const useAuthLayout = (): UseAuthLayoutReturn => {
  /**
   * bodyにauth-layoutクラスを追加する副作用
   */
  const setupBodyClass = (): void => {
    // マウント時にクラスを追加
    document.body.classList.add('auth-layout');
  };

  // useEffectで副作用を登録
  useEffect(() => {
    setupBodyClass();
    
    // アンマウント時にクラスを削除するクリーンアップ関数を返す
    return () => {
      document.body.classList.remove('auth-layout');
    };
  }, []);

  return {
    setupBodyClass,
  };
};

export default useAuthLayout; 